/* Dabrana · header inline search — turns the header search icon into a slide-down search box
   instead of navigating to /search. Self-contained, runs on every page. */
(function(){
  function injectCSS(){
    if(document.getElementById('dh-search-css'))return;
    var css=''+
    '.dh-search-pop{position:fixed;z-index:99000;display:flex;align-items:center;gap:10px;'+
      'width:min(380px,calc(100vw - 24px));padding:8px 8px 8px 16px;'+
      'background:rgba(13,11,8,.96);-webkit-backdrop-filter:blur(16px);backdrop-filter:blur(16px);'+
      'border:1px solid rgba(201,161,90,.34);border-radius:999px;'+
      'box-shadow:0 18px 44px rgba(0,0,0,.5),0 0 0 1px rgba(0,0,0,.3);'+
      'opacity:0;transform:translateY(-8px) scale(.98);transform-origin:top right;pointer-events:none;'+
      'transition:opacity .28s cubic-bezier(.22,1,.36,1),transform .28s cubic-bezier(.22,1,.36,1)}'+
    '.dh-search-pop.is-open{opacity:1;transform:translateY(0) scale(1);pointer-events:auto}'+
    '.dh-search-pop svg{flex:none;color:#C9A15A;opacity:.85}'+
    '.dh-search-pop input{flex:1;min-width:0;height:34px;background:none;border:none;outline:none;'+
      'font-family:"Jost",-apple-system,Helvetica,Arial,sans-serif;font-size:14.5px;font-weight:300;'+
      'letter-spacing:.01em;color:#F8F5EF;caret-color:#C9A15A}'+
    '.dh-search-pop input::placeholder{color:rgba(248,245,239,.45)}'+
    '.dh-search-pop button{flex:none;width:38px;height:38px;display:grid;place-items:center;cursor:pointer;'+
      'border:none;border-radius:50%;background:#C9A15A;color:#0d0b08;transition:background .2s ease}'+
    '.dh-search-pop button:hover{background:#DBBE86}'+
    '.dh-search-pop button svg{color:#0d0b08;opacity:1}'+
    '@media(max-width:600px){.dh-search-pop{left:12px !important;right:12px !important;width:auto !important;transform-origin:top center}}'+
    '@media(prefers-reduced-motion:reduce){.dh-search-pop{transition:opacity .2s linear}}';
    var st=document.createElement('style');st.id='dh-search-css';st.textContent=css;
    document.head.appendChild(st);
  }

  function init(){
    var icon=document.querySelector('.dh-head__ico a[aria-label="Search"], .dh-head a[aria-label="Search"], a[aria-label="Search"]');
    if(!icon||icon.dataset.dhSearch)return;
    icon.dataset.dhSearch='1';
    injectCSS();

    var pop=document.createElement('form');
    pop.className='dh-search-pop';
    pop.setAttribute('role','search');
    pop.action='/search';pop.method='get';
    pop.innerHTML=
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>'+
      '<input type="search" name="q" placeholder="Search fragrances\u2026" autocomplete="off" aria-label="Search fragrances">'+
      '<input type="hidden" name="type" value="product">'+
      '<button type="submit" aria-label="Search"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h13"/><path d="M13 6l6 6-6 6"/></svg></button>';
    document.body.appendChild(pop);
    var input=pop.querySelector('input[name="q"]');

    function place(){
      var r=icon.getBoundingClientRect();
      pop.style.top=(r.bottom+10)+'px';
      if(window.innerWidth<=600){
        pop.style.left='';pop.style.right='';
      }else{
        var right=Math.max(12,window.innerWidth-r.right);
        pop.style.right=right+'px';
        pop.style.left='auto';
      }
    }
    var open=false;
    function show(){place();pop.classList.add('is-open');open=true;setTimeout(function(){input.focus();},60);}
    function hide(){pop.classList.remove('is-open');open=false;}

    icon.addEventListener('click',function(e){
      e.preventDefault();e.stopPropagation();
      if(open)hide();else show();
    });
    document.addEventListener('click',function(e){
      if(open&&!pop.contains(e.target)&&e.target!==icon&&!icon.contains(e.target))hide();
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&open)hide();});
    window.addEventListener('resize',function(){if(open)place();});
    window.addEventListener('scroll',function(){if(open)place();},{passive:true});
    pop.addEventListener('submit',function(e){
      if(!input.value.trim()){e.preventDefault();input.focus();}
    });
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
